// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#resolve-conflicts[data-v-a0d25866] {\n  display: flex;\n  position: fixed;\n  z-index: 10000;\n  bottom: 0;\n  max-width: 900px;\n  width: 100vw;\n  margin: auto;\n  padding: 20px 0;\n}\n#resolve-conflicts button[data-v-a0d25866] {\n    margin: auto;\n    box-shadow: 0 0 10px var(--color-box-shadow);\n}\n", ""]);
// Exports
module.exports = exports;
